import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '@config/app.config';
import { AccountingGroupsRepository } from '@core/repositories/accounting-groups.repository';
import { AccountingGroup } from '@shared/interfaces/accounting-group';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiAccountingGroupsRepository implements AccountingGroupsRepository {
  public url = this.appConfig.URL + '/amlcontrol/v1/accountingGroups/';

  constructor(public appConfig: AppConfig, public http: HttpClient) {}

  getItems(): Observable<any> {
    return this.http.get(this.url);
  }

  add(accountingGroup: AccountingGroup): Observable<any> {
    const data = {
      data: {
        id: accountingGroup.id,
        type: 'AccountingGroup',
        attributes: {
          name: accountingGroup.name
        }
      }
    };
    return this.http.post(this.url, data);
  }

  edit(accountingGroup: AccountingGroup): Observable<any> {
    const data = {
      data: {
        id: accountingGroup.id,
        type: 'AccountingGroup',
        attributes: {
          name: accountingGroup.name
        }
      }
    };
    return this.http.put(this.url, data);
  }

  delete(item: any): Observable<any> {
    return this.http.delete(this.url + item);
  }
}
